import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-cebai-grey-lightest border-t border-t-cebai-grey-mid text-cebai-base-dark sticky bottom-0 left-0 right-0 z-50"
}
const _hoisted_2 = { class: "max-w-screen-xl mx-auto p-6 pt-0.5" }
const _hoisted_3 = { class: "max-w-3xl" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Cookies", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " This website uses cookies. Some are necessary to help the website work properly and can't be switched off, others are optional and help us to enhance your experience. ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Are you happy to accept these cookies?", -1)
const _hoisted_7 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!

  return (!_ctx.isCookieBannerDismissed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _createElementVNode("p", null, [
                  _createTextVNode(" You can change your settings at any time by visiting the "),
                  _createVNode(_component_router_link, { to: { name: 'cookie-policy' } }, {
                    default: _withCtx(() => [
                      _createTextVNode("cookie policy")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" from the bottom of any page. ")
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AppButton, {
                class: "mr-2",
                type: "primary",
                onClick: _ctx.acceptAllCookies
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Yes I'm happy ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_AppButtonRouterLink, {
                type: "outline",
                to: { name: 'cookie-policy' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Manage cookies ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}